import { render, staticRenderFns } from "./StandardProtocol.vue?vue&type=template&id=3133b67c&scoped=true"
import script from "./StandardProtocol.vue?vue&type=script&lang=js"
export * from "./StandardProtocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3133b67c",
  null
  
)

export default component.exports